import * as TOP_CATEGORIES_IN_TOP_LOCATIONS from './topCategoriesTopLocations';
import POPULAR_CATEGORIES_IN_BENDIGO from './popularCategoriesBendigo';
import POPULAR_CATEGORIES from './popularCategories';

export {
  TOP_CATEGORIES_IN_TOP_LOCATIONS,
  POPULAR_CATEGORIES_IN_BENDIGO,
  POPULAR_CATEGORIES,
};
